export default __webpack_public_path__ + "static/media/contract-address.1e8c2545.png";